import type { StyleChildProps } from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import FontFamily from 'hb-builder/components/common/SettingsLibrary/CommonSettings/FontFamily';
import { useBuilderConfigContext } from 'hb-builder/hooks';

const Subline = ({ item, handleBulkChange, parentItem }: StyleChildProps) => {
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();
  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };

  return (
    <>
      <FontFamily
        settingKey="textFontFamily"
        item={item}
        onChange={handleBulkChange}
      />
      {parentItem.attributes?.sublineColorMode !== 'different' && (
        <>
          <ColorSetting
            settingKey="textColor"
            title={s__('Builder|Text color')}
            transparent={false}
            item={item}
            onChange={handleBulkChange}
            {...colorSettingsProps}
          />
          <ColorSetting
            settingKey="textBackgroundColor"
            title={s__('Builder|Background color')}
            transparent
            item={item}
            onChange={handleBulkChange}
            {...colorSettingsProps}
          />
        </>
      )}
    </>
  );
};

export default Subline;
